import Navbar from "../components/navbar";

import ModalVideo from 'react-modal-video';
import "../../node_modules/react-modal-video/css/modal-video.css"
import React, { useEffect, useState, useMemo } from 'react'
import Youtubeembed from "../components/youtubeembed";
import axios from "axios";
import Footer from "../components/footer";
import curvedBanner from "../assect/images/bg/dl_curvedimg_troy.png";
import MapComponent from "../components/GoogleMap";
import iony from "../assect/images/iony.svg";
import shs from "../assect/images/shs.png";
import rensco from "../assect/images/rensco.svg";
import downtown from "../assect/images/downtown.png";
const embedId = "jjJ8Sd9RWPQ";
// const embedId2 = "QWPehrvUhmg";
const embedId2 = "XWUEv2yvg5g";

export default function DiscoverTroy() {
    const [mapMarkers, setMapMarkers] = useState([]);
    const [isOpen, setOpen] = useState(false)
    const [properties, setProperties] = useState([])

    function removeDuplicates(arr) {
        const uniqueObjects = [];
        const seenObjects = new Set();

        for (const obj of arr) {
            const stringOfObj = JSON.stringify(obj);
            if (!seenObjects.has(stringOfObj)) {
                uniqueObjects.push(obj);
                seenObjects.add(stringOfObj);
            }
        }
        return uniqueObjects;
    }
    const fetchProperties = async () => {
        // const apiPath = `${process.env.REACT_APP_API_URL}api/DimoraProperties?includeAllImages=false`
        const apiPath = `${process.env.REACT_APP_API_URL}api/Properties/search`;
        const payload = {
            page: 1,
            pageSize: 10000,
            sortBy: "availableDt",
            sortOrder: "asc"
        }

        const allProperties = await axios.post(apiPath, payload);
        // const allProperties = await axios.get(apiPath)
        setProperties(allProperties.data.properties)
    }

    const markers = useMemo(() => {
        const markerList = properties.map(item => ({
            id: item.id,
            key: item.address,
            location: { lat: item.lat, lng: item.lng },
            beds: item.beds,
            baths: item.baths,
            city: item.city,
            price: item.price
        }));
        return markerList
        // return removeDuplicates(markerList);
    }, [properties]);

    useEffect(() => {
        setMapMarkers(markers);
    }, [markers]);

    useEffect(() => {
        fetchProperties();
    }, [])

    return (
        <div style={{ backgroundColor: "#f0eadd" }}>
            <Navbar navClass="defaultscroll sticky" menuClass="navigation-menu nav-right" />
            <div className="top-half top-half d-table w-100 pt-5">
                <section className="bg-half-116" style={{ backgroundImage: `url(${curvedBanner})` }}>
                </section>
            </div>

            <section className="section-50 pb-0">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-12">
                            <p className="mb-md-5 mb-sm-3 sub_heading">Discover Troy</p> 
                            <div className="p-0 pb-3">
                                <div className="row align-items-center justify-content-center g-4">
                                    <div className="col-xl-8">
                                        <div className="d-flex flex-md-row flex-column gap-sm-4 gap-2">
                                            <div className="card_custom w-100">
                                                <Youtubeembed embedId={embedId} />
                                            </div>
                                            <div className="card_custom w-100">
                                                 <Youtubeembed embedId={embedId2} />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-xl-8">
                                        <ul className="d-flex gap-3 list-unstyled website_logo">
                                            <li><a href="https://www.iloveny.com/places-to-go/capital-saratoga/" target="_blank"><img src={iony} className="img-fluid"/></a></li>
                                            <li><a href="https://home.shakerheritage.org/history-watervliet/" target="_blank"><img src={shs} className="img-fluid"/></a></li>
                                            <li><a href="https://www.renscochamber.com/living-here/discover-troy/" target="_blank"><img src={rensco} className="img-fluid"/></a></li>
                                            <li><a href="https://www.downtowntroyny.org/" target="_blank"><img src={downtown} className="img-fluid"/></a></li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="w-100 mt-sm-5 mt-3">
                    <div className="card map border-0 sticky-bar-400">
                        <div className="card-body p-0">
                            {mapMarkers.length > 0 ? <MapComponent markers={mapMarkers} /> : null}
                        </div>
                    </div>
                </div>

            </section>
            <Footer />
        </div>

    )
}
